import {
    call,
    put,
    select,
    takeLatest,
} from 'redux-saga/effects';
import camelize from 'camelize';

import axios from '../../../services/axios';
import { getDefaultHeaders } from '../../../helpers/http/getDefaultHeaders';
import { retryWithRefreshToken } from '../../../helpers/sagas/retryWithRefreshToken';

import * as CLEARINGS_TYPES from '../../actions/financials/clearings/types';
import * as CLEARINGS_ACTIONS from '../../actions/financials/clearings';
import * as TOAST_ACTIONS from '../../actions/toast';
import * as FINANCIALS_SELECTORS from '../../selectors/financilas';
import { HTTP_METHOD } from '../../../const/http/HTTP_METHOD';
import { HTTP_STATUS_CODE } from '../../../const/http/HTTP_STATUS_CODE';
import { API_ADMIN_COMPANY_CLEARINGS_LIST_ROUTE } from '../../../const/API_URL';

function* getClearings(action) {
    const defaultHeaders = yield getDefaultHeaders();
    const { page, showAll } = yield select(FINANCIALS_SELECTORS.clearingsListSelector);

    try {
        yield put(CLEARINGS_ACTIONS.setClearingsLoading({ loading: true }));
        const res = yield call(axios.request, {
            _action: action,
            method: HTTP_METHOD.GET,
            url: API_ADMIN_COMPANY_CLEARINGS_LIST_ROUTE,
            headers: defaultHeaders,
            params: {
                page: showAll ? 0 : page,
            },
        });

        const { data } = res;
        const { code, result } = data;
        if (code === HTTP_STATUS_CODE.OK) {
            const { items, itemsCount, pagesCount } = result;
            const clearings = items.map((item) => {
                const clearing = camelize(item);

                return {
                    id: clearing.id,
                    number: clearing.name,
                    date: clearing.date,
                    totalAmount: clearing.totalAmount,
                    url: clearing.url,
                };
            });
            yield put(CLEARINGS_ACTIONS.setClearings({ clearings, itemsCount, pagesCount }));
        }
    } catch (error) {
        function* handleFail() {
            yield put(TOAST_ACTIONS.showToast({
                message: 'clearings.get.error',
                appearance: 'error',
            }));
        }

        if (error?.response?.status === HTTP_STATUS_CODE.UNAUTHORIZED) {
            yield call(retryWithRefreshToken, {
                action,
                onFail: handleFail,
                onError: handleFail,
            });
            return;
        }
        yield call(handleFail);
    } finally {
        yield put(CLEARINGS_ACTIONS.setClearingsLoading({ loading: false }));
    }
}

export const clearingsListSaga = [
    takeLatest(CLEARINGS_TYPES.CLEARINGS_GET, getClearings),
];
